import React from 'react';
import DropDown from '../dropdown';
import { Customers } from '../../../api/services/next';

const CustomerDropDown = (props) => {
	return (
		<DropDown
			api={Customers.GetCustomers}
			search
			textField='Name'
			valueField='Id'
			{...props}
		/>
	);
};

export default CustomerDropDown;
